import { IListReport } from '@epicuro-next/data/reporting-api';

export const generateDefaultReport = (
  productListId: string,
  currency: string | null,
): IListReport => ({
  productListId,
  externalOwnerId: '',
  uniqueViews: 0,
  placed: {
    products: 0,
    baskets: 0,
    revenue: {
      currency,
      value: 0,
    },
    revenueInRequestedCurrency: {
      currency,
      value: 0,
    },
    revenueDateConstraint: undefined,
  },
  added: {
    products: 0,
    baskets: 0,
    revenue: {
      currency,
      value: 0,
    },
  },
});
